export function listPaymentChannelRulesV1(send) {
  return (...args) =>
    send(
      {
        path: '/v1/paymentChannelRules',
        pathParameters: {},
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
